/**
 * Copyright IBM Corp. 2022, 2026
 */

import { FlightIcon, Text } from '@hashicorp/mds-react/components'
import {
	LEAD_EMAIL_URL_PARAM,
	LEAD_ID_URL_PARAM,
} from 'components/materia/form/profile-form/utils'
import type { SubmissionProps } from 'components/materia/prefooter-newsletter-form'
import s from './style.module.css'

export default function SubmitMessage({ submitStatus, lead }: SubmissionProps) {
	const isSuccessful = submitStatus === 'success'
	const iconName = isSuccessful ? 'check-circle-fill' : 'alert-triangle'
	const iconColor = isSuccessful
		? 'var(--mds-color-foreground-success)'
		: 'var(--mds-color-foreground-warning)'

	return (
		<div className={s.submittedMsg} data-test-id="submitMessage">
			<FlightIcon name={iconName} color={iconColor} />
			<Text.Body color="faint" size="200">
				{
					// Return error message if submission was not successful
					isSuccessful ? (
						<>
							Thanks for subscribing! We want to make sure you get the right
							content from us. Please{' '}
							<a
								href={`/newsletter-update?${LEAD_ID_URL_PARAM}=${lead?.id}&${LEAD_EMAIL_URL_PARAM}=${lead?.email}`}
								className={s.link}
							>
								tell us a bit about yourself
							</a>
							.
						</>
					) : (
						<>
							We’re having trouble getting you subscribed. Try again or reach
							out to{' '}
							<a href="mailto:hello@hashicorp.com" className={s.link}>
								hello@hashicorp.com
							</a>
						</>
					)
				}
			</Text.Body>
		</div>
	)
}
